<semeris-status-shell>
  <i class="sui-icon sui-icon-warning-circle text-4xl! text-warning" aria-hidden="true"></i>
  <div class="flex flex-col gap-2">
    <h1 class="text-2xl font-semibold text-surface-content">Can't reach Semeris right now</h1>
    <p class="text-md text-muted">We couldn't load your account. Check your connection, then try again.</p>
  </div>
  <button type="button" class="sui-btn sui-btn-primary sui-btn-sm" (click)="retry()">
    <i class="sui-icon sui-icon-arrow-clockwise" aria-hidden="true"></i>
    Try again
  </button>
</semeris-status-shell>
